<template>
  <div id="app">
    <GameMain />
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>Edirne Tava Ciğer Oyunu</strong> &copy; 2019
          <a href="https://www.facebook.com/ertac.paprat"> Ertaç Paprat</a>
          tarafından <a href="https://www.wikiwand.com/tr/Edirne">Edirne</a>'de
          geliştirildi.
        </p>
        <p>Version: {{ version }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import GameMain from "./components/GameMain.vue";
import { version } from "../package.json";
export default {
  name: "app",
  components: {
    GameMain
  },
  data() {
    return {
      version: version
    };
  }
};
</script>

<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/bulma-switch@2.0.0/dist/css/bulma-switch.min.css";
#app {
  align-content: center;
  justify-content: space-around;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}
.footer {
  align-self: flex-end;
}
</style>
